import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  getDataSession(key: string) {
    if(localStorage.getItem(key) !== null){
      if(localStorage.getItem(key) === 'undefined'){
        return ''
      }else{
        return JSON.parse(localStorage.getItem(key));
      }
    }else {
      return '';
    }
  }

  setDataSession(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }
}
